module.exports = __webpack_public_path__ + "img/apidays-2020-facts.8a891f2b.png";